// extracted by mini-css-extract-plugin
module.exports = {"box":"sampleCnfirmation_box__T3tPL","content":"sampleCnfirmation_content__36_Nv"};